<template>
  <a
    v-if="props.type === 'link' && buttonIsVisible && props.href !== ''"
    class="hcl-button hcl-button-type-link btn btn-sm"
    :class="props.variant"
    role="button"
    :id="props.id"
    :title="props.label"
    :disabled="props.disabled"
    :href="props.href"
    v-bind="props.widgetAttributes"
  >
    <span
      v-if="props.icon"
      class="button-image"
    >
      <i :class="props.icon"></i>
    </span>
    <span
      v-if="props.title"
      class="button-title"
    >{{ props.title }}</span>
  </a>
  <a
    v-else-if="props.type === 'link' && buttonIsVisible && props.href === ''"
    class="hcl-button hcl-button-type-link btn btn-sm"
    :class="props.variant"
    role="button"
    :id="props.id"
    :title="props.label"
    :disabled="props.disabled"
    v-bind="props.widgetAttributes"
  >
    <span
      v-if="props.icon"
      class="button-image"
    >
      <i :class="props.icon"></i>
    </span>
    <span
      v-if="props.title"
      class="button-title"
    >{{ props.title }}</span>
  </a>
  <a
    v-else-if="props.type === 'popup' && buttonIsVisible"
    class="hcl-button hcl-button-type-popup btn btn-sm"
    :class="props.variant"
    role="button"
    :id="props.id"
    :title="props.label"
    :disabled="props.disabled"
    v-on:click.stop.prevent="onButtonPopupClick(props.href)"
  >
    <span
      v-if="props.icon"
      class="button-image"
    >
      <i :class="props.icon"></i>
    </span>
    <span
      v-if="props.title"
      class="button-title"
    >{{ props.title }}</span>
  </a>
  <button
    v-else-if="props.type === 'button' && buttonIsVisible"
    class="hcl-button hcl-button-type-button btn btn-sm"
    :class="props.variant"
    type="button"
    role="button"
    :id="props.id"
    :title="props.label"
    :disabled="props.disabled"
    v-on:click.stop.prevent="onButtonButtonClick()"
  >
    <span
      v-if="props.icon"
      class="button-image"
    >
      <i :class="props.icon"></i>
    </span>
    <span
      v-if="props.title"
      class="button-title"
    >{{ props.title }}</span>
  </button>
  <button
    v-else-if="props.type === 'toggle' && buttonIsVisible"
    class="hcl-button hcl-button-type-toggle btn btn-sm"
    :class="props.variant"
    type="button"
    role="button"
    :id="props.id"
    :title="props.label"
    :disabled="props.disabled"
    v-on:click.stop.prevent="onButtonToggleClick()"
  >
    <span
      v-if="props.icon"
      class="button-image"
    >
      <i :class="props.icon"></i>
    </span>
    <span
      v-if="props.title"
      class="button-title"
    >{{ props.title }}</span>
  </button>
  <hcl-dropdown
    v-else-if="props.type === 'kebab' && buttonIsVisible"
    class="hcl-button hcl-button-type-kebab inline"
    type="kebab"
    :id="props.id"
    :title="props.label"
    :disabled="props.disabled"
  >
    <slot name="kebab">
      <template
        v-for="item in menuItemsRef"
        :key="item.id"
      >
        <a
          class="dropdown-item"
          :class="{ active: item.active, disabled: item.disabled }"
          v-bind="generateWidgetDataAttributes(item)"
          :widget="item.widget?.widget"
          @click="onDropDownMenuSelectionChange(item)"
        >
          {{ item.title }}
        </a>
      </template>
    </slot>
  </hcl-dropdown>
  <hcl-dropdown
    v-else-if="props.type === 'dropdown' && buttonIsVisible"
    class="hcl-button hcl-button-type-dropdown inline"
    type="dropdown"
    :button-class="props.variant"
    :id="props.id"
    :title="props.label"
    :disabled="props.disabled"
    :text="props.title"
    :responsive="props.responsive"
    :icon="props.icon"
  >
    <slot name="dropdown">
      <template
        v-for="item in menuItemsRef"
        :key="item.id"
      >
        <a
          class="dropdown-item"
          :class="{ active: item.active, disabled: item.disabled }"
          @click="onDropDownMenuSelectionChange(item)"
        >
          {{ item.title }}
        </a>
      </template>
    </slot>
  </hcl-dropdown>
  <button
    v-else-if="props.type === 'submit' && buttonIsVisible"
    class="hcl-button hcl-button-type-submit btn"
    :class="props.variant"
    type="submit"
    role="button"
    :id="props.id"
    :title="props.label"
    :disabled="props.disabled"
    v-bind="props.widgetAttributes"
  >
    <span
      v-if="props.widgetAttributes.icon"
      class="button-image"
    >
      <i :class="props.widgetAttributes.icon"></i>
    </span>
    <span
      v-if="props.widgetAttributes.value"
      class="button-title"
    >{{ props.widgetAttributes.value }}</span>
  </button>
  <button
    v-else-if="props.type === 'submit-ajax' && buttonIsVisible"
    class="hcl-button hcl-button-type-submit-ajax btn"
    :class="props.variant"
    type="submit"
    role="button"
    :id="props.id"
    :title="props.label"
    :disabled="props.disabled"
    v-on:click.stop.prevent="onButtonSubmitAjaxClick()"
  >
    <span
      v-if="props.icon"
      class="button-image"
    >
      <i :class="props.icon"></i>
    </span>
    <span
      v-if="props.title"
      class="button-title"
    >{{ props.title }}</span>
  </button>
  <a
    v-else-if="props.type === 'widget' && props.widgetElement === 'a' && buttonIsVisible"
    class="hcl-button hcl-button-type-widget-a btn btn-sm"
    :class="props.variant"
    :title="props.label"
    :id="props.id"
    v-bind="props.widgetAttributes"
  >
    <span
      v-if="props.icon"
      class="button-image"
    >
      <i :class="props.icon"></i>
    </span>
    <span
      v-if="props.title"
      class="button-title"
    >{{ props.title }}</span>
  </a>
  <input
    v-else-if="props.type === 'widget' && props.widgetElement === 'input' && buttonIsVisible"
    class="hcl-button hcl-button-type-widget-input btn btn-sm"
    :class="props.variant"
    :title="props.label"
    type="submit"
    :id="props.id"
    v-bind="props.widgetAttributes"
  />
</template>

<script setup lang="ts">
import { ref, Ref, computed, inject, watch } from 'vue'

import { useDataStore } from '@/stores/data'
import { useStateStore } from '@/stores/state'

import HclDropdown from '@/components/Dropdown/Dropdown.vue'

import type { DefinitionButtonTypes, DefinitionButtonMenuItem, EventButtonClicked, EventListGlobalSelectAllChanged } from '@/components/types'

interface Props {
  /**
   * Which type of button to render:
   *   - link
   *   - popup
   *   - button
   *   - toggle
   *   - kebab
   *   - dropdown
   *   - submit
   *
   *   - submit-ajax
   *   - widget (a or input)
   */
  type: DefinitionButtonTypes
  /**
   * Whether or not the button is hidden.
   */
  hidden?: boolean
  /**
   * href of button (only for type 'link' and 'popup').
   */
  href?: string
  /**
   * Which button variant to render, must be a Bootstrap 4 CSS class.
   */
  variant: string
  /**
   * ID of the Button.
   */
  id: string
  /**
   * Label of the button, text which is displayed on hover.
   */
  label?: string
  /**
   * Title of the button, text inside button.
   */
  title: string
  /**
   * Whether or not the button is disabled.
   */
  disabled?: boolean
  /**
   * Icon of the button, icon inside button as CSS class (only for type 'link', 'popup' and 'toggle').
   */
  icon: string
  /**
   * HTML Attributes to add to the Base HTML element (only for type 'widget').
   */
  widgetAttributes: any
  /**
   * Array of items to display inside Dropdown or Kebab Menu (only for type 'dropdown' and 'kebab').
   */
  menuItems?: DefinitionButtonMenuItem[] | undefined
  /**
   * Data as an JS object.
   */
  data?: any
  /**
   * Base HTML element to render (only for type 'widget').
   */
  widgetElement: string
  /**
   * Whether or not the button is responsive.
   */
  responsive?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  data: undefined,
  disabled: false,
  hidden: false,
  href: '',
  icon: '',
  id: '',
  label: '',
  menuItems: undefined,
  title: '',
  type: 'link',
  variant: 'btn-primary',
  widgetAttributes: {},
  widgetElement: '',
  responsive: false
})

const emit = defineEmits(['hcl-button-clicked', 'hcl-list-global-select-all-changed'])

const toolbarId: string = inject('toolbarId', '')

const { get } = useDataStore()
const { getBlockGroupNameValue } = useStateStore()

const windowRef = ref(window)
const menuItemsRef: Ref<DefinitionButtonMenuItem[] | undefined> = ref(undefined)

const buttonIsVisible = computed(() => {
  if (!toolbarId) return !props.hidden

  const isButtonHidden = getBlockGroupNameValue(toolbarId, props.id, 'hidden')

  if (typeof isButtonHidden.value === 'undefined') return !props.hidden

  return !isButtonHidden.value
})

const generateWidgetDataAttributes = (item: any) => {
    const data = {}
    if (item?.widget?.data && typeof item.widget.data === 'object') {
      for (const d of Object.keys(item.widget.data)) {
        const kebabCaseKey = d.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase()
        data["data-" + kebabCaseKey] = item.widget.data[d]        
      }
    }
    return data
}

const onButtonPopupClick = (link: string) => {
  emit('hcl-button-clicked', { type: props.type, id: props.id } as EventButtonClicked)

  const pHeight = windowRef.value.innerHeight - 10
  const pWidth = Math.ceil((windowRef.value.innerWidth - 10) / 1.5)

  windowRef.value.open(
    link,
    'popUpWindow',
    `height=${pHeight}, width=${pWidth}, left=10, top=10, resizable=yes, scrollbars=yes`
  )
}

const onButtonButtonClick = () => {
  emit('hcl-button-clicked', { type: props.type, id: props.id } as EventButtonClicked)
}

const onButtonToggleClick = () => {
  emit('hcl-button-clicked', { type: props.type, id: props.id } as EventButtonClicked)
}

const onDropDownMenuSelectionChange = (menuItem: DefinitionButtonMenuItem) => {

  const bucketToolbar = get(toolbarId)

  if (menuItem.data) {
    bucketToolbar.data = menuItem.data ?? {}
    updateMenuItemsRef()
  }

  const mergedData = {
    ...props.data,
    ...bucketToolbar
  }

  if (Object.keys(mergedData).length === 0) return

  if (menuItem.action === 'page' || menuItem.action === 'redirect') {
    let url = menuItem.url

    if (menuItem.urlgenerate) {
      const append: string[] = []
      let data
      let found

      for (const outputKey in menuItem.urlgenerate) {
        found = true
        const value = menuItem.urlgenerate[outputKey]
        if (value.includes('.')) {
          data = mergedData
          for (const element of value.split('.')) {
            if (element in data) {
              data = data[element]
            } else {
              found = false
            }
          }
        } else {
          data = outputKey in mergedData ? mergedData[outputKey] : value
        }

        if (found) {
          append.push(`${outputKey}=${data}`)
        }
      }

      url += '?' + append.join('&')
    }

    windowRef.value.open(url, '_link')
  }

  if (menuItem.action === 'select-all') {
    if (bucketToolbar) bucketToolbar.selectAll = true
    emit('hcl-list-global-select-all-changed', { selection: true } as EventListGlobalSelectAllChanged)

  }
  if (menuItem.action === 'deselect-all') {
    if (bucketToolbar) bucketToolbar.selectAll = false
    emit('hcl-list-global-select-all-changed', { selection: false } as EventListGlobalSelectAllChanged)
  }
}

const onButtonSubmitAjaxClick = () => {
  emit('hcl-button-clicked', { type: props.type, id: props.id } as EventButtonClicked)
}

if (props.type === 'kebab' || props.type === 'dropdown') {
  menuItemsRef.value = props.menuItems ?? []
}

const updateMenuItemsRef = () => {
  if (!menuItemsRef.value || menuItemsRef.value.length === 0) return

  const bucketToolbar = get(toolbarId)

  const mergedData = {
    ...props.data,
    ...bucketToolbar
  }

  if (Object.keys(mergedData).length === 0) return

  for (const item of menuItemsRef.value) {
    if (item.disabledCheck) {
      let data

      if (item.disabledCheck.data.includes('.')) {
        data = mergedData
        for (const element of item.disabledCheck.data.split('.')) {
          if (element in data) {
            data = data[element]
          } else {
            break
          }
        }
      } else {
        data = mergedData[item.disabledCheck.data]
      }

      const value = item.disabledCheck.value
      const operator = item.disabledCheck.operator

      if (operator === '===') item.disabled = data === value
      if (operator === '!==') item.disabled = data !== value
      if (operator === '>') item.disabled = data > value
      if (operator === '>=') item.disabled = data >= value
      if (operator === '<') item.disabled = data < value
      if (operator === '<=') item.disabled = data <= value
    }
  }
}

updateMenuItemsRef()

watch(
  () => props.data,
  () => {
    updateMenuItemsRef()
  }
)
</script>

<style lang="scss" scoped>
.hcl-button {
  display: flex;
  align-items: center;
  min-height: 1.8rem;

  &.btn-compact {
    padding: 0rem 1rem;
  }

  .btn-dark {
    color: #fff;
    background-color: #495057;
    border-color: #495057;
  }

  .button-image+.button-title {
    margin-left: 0.5rem;
  }

  .button-image {
    display: flex;

    i[class*='eii--']:not([class*=eii--stack]) {
      top: 0;
    }
  }
}
</style>
